import { Suspense } from '@common/components/utility';
import { useDoubleClickHandler } from '@common/hooks';
import { SalesPackageModel } from '@common/models';
import { SalesItemService } from '@common/services';
import { formatCurrency, htmlFrom } from '@common/utils';
import { isEmpty, orderBy } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';
import { PulseLoader } from 'react-spinners';

interface IPriceCheckPackageTable {
  items: SalesPackageModel[];
}
export const PriceCheckPackageTable = observer(
  ({ items }: IPriceCheckPackageTable) => {
    const [isClickedArray, setIsClickedArray] = React.useState<boolean[]>([]);
    const expandRow = (index: number) => {
      const arr = [...isClickedArray];
      arr[index] = !arr[index];
      setIsClickedArray(arr);
    };
    const rowClickedHandler = useDoubleClickHandler({
      onDoubleClick: expandRow,
    });
    return (
      <Suspense
        tag={SalesItemService.tags.fetchSalesItems}
        waiting={<PulseLoader />}
      >
        <div className="table-frozen-header mt-1" style={{ height: '20rem' }}>
          <Table hover size="sm" style={{ tableLayout: 'fixed' }}>
            <thead>
              <tr>
                <th>Description</th>
                <th
                  className="text-start"
                  style={{ width: '15rem', paddingRight: '2rem' }}
                >
                  SKU
                </th>
                <th className="text-start" style={{ width: '5rem' }}>
                  Price
                </th>
              </tr>
            </thead>
            <tbody>
              {isEmpty(items) && (
                <tr>
                  <td>No sales packages found.</td>
                  <td></td>
                  <td></td>
                </tr>
              )}
              {!isEmpty(items) &&
                orderBy(items, ['name', 'sortOrder']).map((item, index) => {
                  return (
                    <tr
                      key={`sales-package-${item.salesPackageId}`}
                      onClick={() => rowClickedHandler(index)}
                    >
                      <td>
                        <div className="d-flex flex-column gap-2">
                          <div>{htmlFrom(item.name)}</div>
                          {isClickedArray[index] && (
                            <div className="d-flex flex-column gap-1">
                              {orderBy(item.contents, 'sortOrder').map((c) => (
                                <div
                                  key={`sales-package-${item.salesPackageId}-details-${c.salesPackageContentId}`}
                                  className="ps-4 petco-smaller"
                                >
                                  {c.salesItemName}{' '}
                                  {c.salesItemOption.displayName}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </td>
                      <td
                        className="text-start"
                        style={{ verticalAlign: 'top', paddingRight: '2rem' }}
                      >
                        {htmlFrom(item.hospitalSKU)}
                      </td>
                      <td
                        className="text-start"
                        style={{ verticalAlign: 'top' }}
                      >
                        {formatCurrency(item.prices[0].price)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </Suspense>
    );
  },
);
